import { useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import AssociationsSearchButton from './AssociationsSearchButton';
import AssociationsSortButtons from './AssociationsSortButtons';
import AssociationsSearchInput from './AssociationsSearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssociationsActionBar() {
  const [showSearchInput, setShowSearchInput] = useState(false);
  const handleSearchToggle = () => {
    setShowSearchInput(!showSearchInput);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      gap: "300",
      children: [/*#__PURE__*/_jsx(AssociationsSearchButton, {
        onSearchToggle: handleSearchToggle,
        showSearchInput: showSearchInput
      }), /*#__PURE__*/_jsx(AssociationsSortButtons, {})]
    }), /*#__PURE__*/_jsx(AssociationsSearchInput, {
      showSearchInput: showSearchInput
    })]
  });
}
export default AssociationsActionBar;